var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._b({attrs:{"value":_vm.value,"items":_vm.placements,"item-value":"short","item-text":"short"},on:{"input":function($event){return _vm.$emit('inupt', $event)}}},'v-autocomplete',_vm.options,false))
}
var staticRenderFns = []

export { render, staticRenderFns }